/*jshint esversion: 6 */
jQuery(window).on('load', function () {
    (function () {
        var segments = location.pathname.split("/");
        if (isInArray('res_comps', segments) || isInArray('res-master-properties', segments) || (isInArray('res_evaluations', segments) && isInArray('sales', segments))) {
            var initialize = function () {
                let searchParam = location.search.indexOf('evaluation');
                if(location.pathname.indexOf('res_evaluations') == -1 || searchParam == -1)
                    document.getElementById("save-comp").addEventListener("click", saveComp);
                if(document.getElementById("delete-comp"))
                    document.getElementById("delete-comp").addEventListener("click", deleteComp);
                TableController.ResComps.init(loadSideNav);
                if($("#open_advance_filter_modal").length){
                    document.getElementById("open_advance_filter_modal").addEventListener("click", openAdvanceFilter);
                    document.getElementById("get_comps_for_table").addEventListener("click", search);
                    document.getElementById("clear_filter").addEventListener("click", clear_filter);
                }
            };

            var openAdvanceFilter = function(e){
                e.preventDefault();
                $('#select-comp').modal('open');
                setModalFields();
            };

            var update_filter_label = function(text,icon){
                $('#open_advance_filter_modal').attr('data-tooltip',text);
                $('.filter_icon').text(icon);
            };
            
            if ($('input.table-search_field').length > 0) {
                $('input.table-search_field').keyup(function () {
                    $("#response_div_map").addClass("hide");
                    $('.table_wrap').removeClass('hide');
                    $('#advance-listings-map').addClass('hide');
                });
            }

            var refresh_filters = function(){
                $("#response_div_map").addClass("hide");
                $('.table-search_field').val('');
                if($.fn.DataTable.isDataTable('#res-comps-table')) {
                    $('#res-comps-table').DataTable().destroy();
                }
                $('#res-comps-table tbody').empty();
                TableController.ResComps.init(loadSideNav);
                $('#select-comp').modal('close');
            };

            var clear_filter = function () {
                $('#check_advance_filter').val(0);
                $('#clear_filter').addClass('hide');
                update_filter_label('Apply Advance Filter','filter_alt');
                refresh_filters();
            };

            var loadListings = function () {
                EvaluationsCommons.initMap();
                EvaluationsCommons.clean();
                var formValues= $("#form_modal").serialize();
                $.ajax({
                    type: "POST",
                    url: $("body").data("base-url") + "res_comps/get_comps",
                    data: formValues,
                    success: function (responseText) {
                        EvaluationsCommons.resetMarkers();
                        $("#comps-modal-table").html();
                        var comp = JSON.parse(responseText);
                        if(comp.data.length){
                            $(comp.data).each(function (index, instance) {
                                EvaluationsCommons.buildListing(instance);
                            });
                            $("#advance-listings-map").removeClass("hide");
                            $("#response_div_map").addClass("hide");
                        }else{
                            $("#advance-listings-map").addClass("hide");
                            $("#response_div_map").removeClass("hide");
                        }
                        EvaluationsCommons.fitBounds();
                        EvaluationsCommons.checkMap();
                    },
                });
            };
            var search = function () {
                $('#check_advance_filter').val(1);
                $('#clear_filter').removeClass('hide');
                update_filter_label('Advance Filter Applied','filter_list');
                refresh_filters();
                if($('#results_format').is(':checked')){
                    $('.table_wrap').addClass('hide');
                    $('#advance-listings-map').removeClass('hide');
                    loadListings();
                }else{
                    $('.table_wrap').removeClass('hide');
                    $('#advance-listings-map').addClass('hide');
                    $("#response_div_map").addClass("hide");
                }
            };
        
            var clearFilters = function () {
                $('#results_format').prop('checked', false);
                var property_type = $('select[name="property_type"]');
                property_type.val("");
                property_type.material_select();
                var state = $('select[name="state"]');
                state.val("");
                state.material_select();
                change_state(state);
                $("label[for='city']").removeClass("active");
                $('[name="filter_street_address"]').val("");
                $('[name="filter_street_address"]').parent().find('label').removeClass('active');
                $('[name="start_date"]').val("");
                $('[name="start_date"]').parent().find('label').removeClass('active');
                $('[name="end_date"]').val("");
                $('[name="end_date"]').parent().find('label').removeClass('active');
                $('[name="square_footage_min"]').val("");
                $('[name="square_footage_min"]').parent().find('label').removeClass('active');
                $('[name="square_footage_max"]').val("");
                $('[name="square_footage_max"]').parent().find('label').removeClass('active');
                $('[name="land_sf_min"]').val("");
                $('[name="land_sf_min"]').parent().find('label').removeClass('active');
                $('[name="land_sf_max"]').val("");
                $('[name="land_sf_max"]').parent().find('label').removeClass('active');
            };

            var setModalFields = function(e){
                clearFilters();
            };

            var doDeleteComp = function () {
                $.ajax({
                    type: "POST",
                    url: $("body").data("base-url") + "res_comps/delete",
                    data: $("#comps-form").serialize(),
                    beforeSend: function (xhr) {
                        startLoading('#slide-out');
                    },
                    success: function (responseText) {
                        var comp = JSON.parse(responseText);
                        if(comp == "existInEval")
                        {
                            Materialize.toast("This comp is currently used in an Evaluation and cannot be deleted.", 2000);
                        }else if (comp.id) {
                            TableController.ResComps.refresh();
                            $('.table_wrap').removeClass('hide');
                            $('#advance-listings-map').addClass('hide');
                            Materialize.toast("Comparative has been removed.", 2000);
                            if (location.pathname.indexOf('/res-master-properties') !== -1) {
                                reload_res_comp_data();
                            }
                        }
                        loadSideNav();
                    },
                    failure: function (errMsg) {
                        Materialize.toast("It was not possible to remove comparative right now.", 2000);
                    }
                }).done(function () {
                    stopLoading('#slide-out');
                    closeForm();
                });
            };

            var deleteComp = function () {
                deleteConfirm(doDeleteComp);
            };

            var clearForm = function () {
                var form = $('#comps-form');
                form[0].reset();
                form.find('.select-wrapper').removeClass('valid');
                form.find('.input').removeClass('valid');
                $("#addToEvaluation").val("");
                $('#image').cropper('destroy');
            };

            var resetForm = function () {
                $('.side-nav').scrollTop(0);
                Utils.unsetIndexes('zonings');
    
                var form = $('#comps-form');
                var output = $('.comps-image-container');
    
                form.find('input:text, input[type="number"], input:password, input:file, textarea').val('');
                form.find('input:radio, input:checkbox').removeAttr('checked').removeAttr('selected');
                
                $("#administrative_area_level_1-error").remove();
                $('#administrative_area_level_1').removeClass('error');
                $("#conditions-error").remove();
                $('#conditions').removeClass('error');
                $("#administrative_area_level_1").val('');
                $("#years").val('');
                $("#conditions").val('');
                $("input[name='zonings[index][id]']").val('');
                $("select[name='zonings[index][zone]']").removeClass('error');
                $("select[name='zonings[index][sub_zone]']").removeClass('error');
                $("select[name='zonings[index][zone]'] option:first-child").attr("selected", "selected");
                $("select[name='zonings[index][sub_zone]']").find('option').remove().end().append($('<option>', {
                    value: '',
                    text: '-- Select a Subtype --'
                }));
                $("input[name='zonings[index][total_sq_ft]']").val('');
                $("input[name='zonings[index][gross_living_sq_ft]']").val('');
                $("input[name='zonings[index][basement_finished_sq_ft]']").val('');
                $("input[name='zonings[index][weight_sf]']").val('');
                $("input[name='zonings[index][basement_unfinished_sq_ft]']").val('');
                $("select[name='zonings[index][zone]']").material_select();
                $("select[name='zonings[index][sub_zone]']").material_select();
    
                $('#administrative_area_level_1').material_select();
                $('#years').material_select();
                $('#conditions').material_select();
                $(".condition-type-option").addClass('enable-type-own');
                $("label[for='condition']").removeClass("active");
                $('.utilities_type_field').removeClass('s12');
                $('.utilities_type_field').addClass('s6');
                $("select[name='frontage'] option:first-child").attr("selected", "selected");
                $("select[name='frontage']").material_select();
                $(".frontage-type-option").addClass('enable-type-own');
                $("select[name='land_dimension'] option:first-child").attr("selected", "selected");
                $("select[name='land_dimension']").material_select();
                $("select[name='sale_status'] option:first-child").attr("selected", "selected");
                $("select[name='sale_status']").material_select();
                $("label[for='states']").removeClass("active");
                $('[name="summary"]').keyup();
                
                $('.property-type-row').each(function (i, val) {
                    if (i !== 0) {
                        $(val).remove();
                    }
                });
                $('.property-type-row').last().find('#subzone_type_custom0-error').remove();
                $('.property-type-row').last().find('.subzone_type_custom').attr('aria-describedby','subzone_type_custom0-error');
                $('.subzone-type-option, .land-type-option').addClass('enable-type-own');
                $('.property_width').removeClass('s3');
                $('.property_width').addClass('s4');
                $('.subzone_width').removeClass('s5');
                $('.subzone_width').addClass('s4');
                $('.property-type-row').find('.zonings.property_type').next('.error').remove();
                $('.property-type-row').find('.zonings.property_sub_type').next('.error').remove();
                $('.property-type-row').find('.zonings.space').next('.error').remove();
                output.css({'background': ''});
                $('.property-type-row').show();
                $('.zoning_block').show();
                $('#id').val("");
                MapController.CompsPin.reset();
                $("input[name='latitude']").val("");
                $("input[name='longitude']").val("");
                $("select[name='offeror_type'] option:first-child").attr("selected", "selected");
                $("select[name='offeror_type']").material_select();
                $('[name="offeror_id"]').find('option').remove().end();
                $('[name="offeror_id"]').material_select();
                $("select[name='acquirer_type'] option:first-child").attr("selected", "selected");
                $("select[name='acquirer_type']").material_select();
                $('[name="acquirer_id"]').find('option').remove().end();
                $('[name="acquirer_id"]').material_select();
                $("input[name='land_size']").removeClass("money-acre");
                $("input[name='land_size']").addClass("postmask-integer");
                $('.standalone-datepicker').each(function() { 
                    $(this).data('daterangepicker').setStartDate(Utils.getToday());
                    $(this).data('daterangepicker').setEndDate(Utils.getToday());
                });
                reloadSelectList('utilities_select','.utilities_select-type-option');
                reloadSelectList('topography','.topography-type-option');
                reloadSelectList('lot_shape','.lot_shape-type-option');
                reloadSelectList('basement','.basement-type-option');
                reloadSelectList('exterior','.exterior-type-option');
                reloadSelectList('roof','.roof-type-option');
                reloadSelectList('electrical','.electrical-type-option');
                reloadSelectList('plumbing','.plumbing-type-option');
                reloadSelectList('heating_cooling','.heating_cooling-type-option');
                reloadSelectList('windows','.windows-type-option');
                reloadSelectList('bedrooms','.bedrooms-type-option');
                reloadSelectList('bathrooms','.bathrooms-type-option');
                reloadSelectList('garage','.garage-type-option');
                reloadSelectList('fencing','.fencing-type-option');
                reloadSelectList('fireplace','.fireplace-type-option');
                MapController.CompsPin.init();
                clearForm();
                iteratePropertyControls();
            };

            var reloadSelectList = function (name,custom_name) {
                $("select[name='"+name+"'] option:first-child").attr("selected", "selected");
                $("select[name='"+name+"']").material_select();
                $(custom_name).addClass('enable-type-own');
            };

            var loadSideNav = function () {
                var buttonSettings = {
                    menuWidth: '50%',
                    edge: 'left',
                    closeOnClick: false,
                    onClose: function (el) {
                        resetForm();
                    }
                };
    
                $('.button-collapse').sideNav(buttonSettings);
    
                var datePickerConfigs = {
                    range: true,
                    closeOnSelect: true,
                    closeOnClear: true,
                    selectMonths: true, // Creates a dropdown to control month
                    selectYears: 15, // Creates a dropdown of 15 years to control year,
                    today: 'Today',
                    clear: 'Clear',
                    close: 'Ok',
                    format: 'mm/dd/yyyy',
                    container: $('#slide-out').find('.container'),
                    onRender: function () {},
                    onClose: function () {
                        $(document.activeElement).blur();
                    }
                };
    
                $('#slide-out').find('.comps-datepicker').pickadate(datePickerConfigs);
                initImageCropper();
    
                var utilSelect = $("#utilities_select");
                var utilInput = $('#utilities_other').parent('.input-field');
    
                // Allow 'Other' selection of Utilities
                var checkUtils = function (e) {
                    if (e.val() === 'other') {
                        utilInput.removeClass('hide');
                    } else if (!utilInput.hasClass('hide')) {
                        utilInput.addClass('hide');
                    }
                };
                utilSelect.on('change', function () {
                    checkUtils($(this));
                });
            };
    
            var initImageCropper = function () {
                $('input[name=property_image_url]').change(function () {
                    var input = this;
                    var url = $(this).val();
                    var ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
    
                    if (input.files && input.files[0] && (ext == "gif" || ext == "png" || ext == "jpeg" || ext == "jpg")) {
                        var reader = new FileReader();
    
                        reader.onload = function (e) {
                            $('#comps-form').find('#image').attr('src', e.target.result);
                            $('#comps-form').find('#image').cropper({
                                aspectRatio: 16 / 9
                            });
                            $('#comps-form').find('.comps-image-container > .file-field').hide();
                        };
                        reader.readAsDataURL(input.files[0]);
                    }
                });
            };

            var saveComp = function () {
                $('#save-comp').attr('disabled',true);
                startLoading('body');
                Utils.setIndexes('zonings', 9);
                var form = $("#comps-form");
                if (form.valid()) {
                    unmaskFields();
                    $('.space').each(function() { 
                        $(this).val($(this).val().replace(/\$|\s|[, ]/g, ''));
                    });
                    
                    var data = new FormData(form[0]);
                    if (form.find('#image').data('cropper') !== undefined) {
                        form.find('#image').cropper('getCroppedCanvas').toBlob(function (blob) {
                            var fileInput = form.find("input[name=property_image_url][type=file]");
                            var filename = '';
    
                            if(fileInput.hasOwnProperty(0)) {
                                fileInput = fileInput[0];
                                if(fileInput.files) {
                                    fileInput = fileInput.files;
                                    if(fileInput.hasOwnProperty(0)) {
                                        fileInput = fileInput[0];
                                        if(fileInput.name) {
                                            filename = fileInput.name;
                                        }
                                    }
                                }
                            }
    
                            if(filename.length === 0) {
                                filename = 'property_image_url';
                            }
    
                            data.append('property_image_url', blob, filename);
                            send(data);
                        },"image/jpeg",0.75);
                    } else {
                        send(data);
                    }
                } else {
                    stopLoading('body');
                    $('#save-comp').attr('disabled',false);
                    Utils.unsetIndexes('zonings', 9);
                    Materialize.toast('Please complete the missing fields.', 3000, 'blue');
                }
            };

            var send = function (data) {
                $.ajax({
                    type: "POST",
                    url: $("body").data("base-url") + "res_comps/save",
                    data: data,
                    cache: false,
                    contentType: false,
                    processData: false,
                    beforeSend: function (xhr) {
                        startLoading('body');
                    },
                    success: function (responseText) {
                        var comp = JSON.parse(responseText);
    
                        if(comp.status=="fail"){
                            Materialize.toast(comp.message,3000);
                            return false;
                        }else if (comp.id) {
                            if (comp.update) {
                                Materialize.toast("Comp has been updated.", 2000);
                            } else {
                                Materialize.toast("Comp has been created.", 2000);
                            }
                            window.location.href = $("body").data("base-url") + "res_comps";
                            // $('.table_wrap').removeClass('hide');
                            // $('#advance-listings-map').addClass('hide');
                            // TableController.ResComps.refresh();
                            // if (location.pathname.indexOf('/res-master-properties') !== -1) {
                            //     reload_res_comp_data();
                            // }
                            // closeForm();
                        }
                        loadSideNav();
                    },
                    failure: function (errMsg) {
                        Materialize.toast("It was not possible to execute that action.", 2000);
                        $('#save-comp').attr('disabled',false);
                        stopLoading('body');
                    }
                }).done(function () {
                    // stopLoading('body');
                });
            };

            var loadPreLoaderImg =  function (url) {
                var output = $('.comps-image-container');
                output.css("background-image", "url('" + url + "')");
                output.css("background-size", "auto 100%");
                output.css("background-position", "center");
                output.css("background-repeat", "no-repeat");
                output.css("background-color", "#f9f9f9");
                $(".comps-image").fadeTo("fast", 0);
            };
    
            var errorPreLoaderImg =  function () {
                $('.comps-image-container').children().first().css('opacity', 1);
            };

            var fillZoning = function (div, zoning,count=null) {
                if(zoning.sub_zone=="Type My Own")
                {
                    div.find('.subzone-type-option').removeClass('enable-type-own');
                    div.find("input[name='zonings[index][subzone_type_custom]']").attr('required',true);
                }else{
                    div.find('.subzone-type-option').addClass('enable-type-own');
                    div.find("input[name='zonings[index][subzone_type_custom]']").attr('required',false);
                }
                div.find("input[name='zonings[index][id]']").val(zoning.id);
                div.find("select[name='zonings[index][zone]']").val(zoning.zone);
                loadSubzoning(div, zoning);
                div.find("select[name='zonings[index][sub_zone]']").val(zoning.sub_zone);
                div.find("input[name='zonings[index][subzone_type_custom]']").val(zoning.subzone_type_custom);
                div.find("input[name='zonings[index][subzone_type_custom]']").attr('aria-describedby','subzone_type_custom'+count+'-error');
                div.find("select[name='zonings[index][zone]']").material_select();
                div.find("select[name='zonings[index][sub_zone]']").material_select();
                div.find("input[name='zonings[index][total_sq_ft]']").val(zoning.total_sq_ft).change();
                div.find("input[name='zonings[index][gross_living_sq_ft]']").val(zoning.gross_living_sq_ft).change();
                div.find("input[name='zonings[index][basement_finished_sq_ft]']").val(zoning.basement_finished_sq_ft).change();
                div.find("input[name='zonings[index][weight_sf]']").val(zoning.weight_sf).change();
                div.find("input[name='zonings[index][basement_unfinished_sq_ft]']").val(zoning.basement_unfinished_sq_ft).change();
    
                div.find('.subzone-type-option').addClass('subzone-type-option'+count);
                var remove=parseInt(count)-1;
                if(count>0)
                    div.find('.subzone-type-option').removeClass('subzone-type-option0');
    
                div.find('.subzone-type-option').removeClass('subzone-type-option'+remove);
                div.find('select.property_sub_type').attr('onchange','change_custom_field(this,`subzone-type-option'+count+'`,`subzone_type_custom'+count+'`,`zone`)');
                div.find('.subzone_type_custom').attr('id','subzone_type_custom'+count);
            };

            var loadSubzoning = function (div, zoning) {
                var subInput = div.find('select.property_sub_type');
                var subType = subInput.attr('data-subtype');
    
                var value = zoning.zone;
                var sub = $.parseJSON(subType);
                var options = '';
                if (typeof sub[value] !== 'undefined') {
                    var children = sub[value].children;
                    if (typeof children !== 'undefined') {
                        for (var child in children) {
                            if (children.hasOwnProperty(child)) {
                                options += "<option value='" + child + "'>" + children[child] + "</option>";
                                $(subInput).attr('disabled', false);
                            }
                        }
                    } else {
                        options = "<option value='0'>No Subtypes</option>";
                        $(subInput).attr('disabled', true);
                    }
                }
    
                if (options.length === 0) {
                    options = "<option value=''>-- Select a Subtype --</option>";
                }
    
                $(subInput).html(options).material_select();
            };

            $("[name='additional_amenities[]']").change(_.debounce(function () {
                var select2Value = $(this).val();
                $("#additional_amenities").val(select2Value);
                $(this).material_select();
            }, 1500));

            var fillInputs = function (id) {
                $.ajax({
                    type: "GET",
                    url: $("body").data("base-url") + "res_comps/get",
                    data: {id: id, normalize: true},
                    success: function (responseText) {
                        var comp = JSON.parse(responseText);
                        if (comp.id) {
                           var flag=false;
                           var property;
                           for (property in comp) {
                               if (comp.hasOwnProperty(property)) {
                                    if (property.toString() === 'zonings') {
                                        for (var j = 0; j < comp[property].length; j++) {
                                            if(comp[property][j].subzone_type_custom!=="")
                                            {
                                                flag=true;
                                            }
                                        }
                                        if(flag)
                                        {
                                            $('.property_width').removeClass('s4');
                                            $('.property_width').addClass('s3');
                                            $('.subzone_width').removeClass('s4');
                                            $('.subzone_width').addClass('s5');
                                        }else{
                                            $('.property_width').removeClass('s3');
                                            $('.property_width').addClass('s4');
                                            $('.subzone_width').removeClass('s5');
                                            $('.subzone_width').addClass('s4');
                                        }
                                    }
                                }
                           }
                            for (property in comp) {
                                if (comp.hasOwnProperty(property)) {
                                    if (property.toString() === 'zonings') {
                                        $('.property-type-row').last().find('#subzone_type_custom0-error').remove();
                                        var initialPropertyTypeDiv = $('.property-type-row').last();
                                        var propertyTypeDiv = initialPropertyTypeDiv.clone();
    
                                        for (var i = 0; i < comp[property].length; i++) {
                                            if (i === 0) {
                                                fillZoning(initialPropertyTypeDiv, comp[property][i],i);
                                            } else {
                                                propertyTypeDiv = initialPropertyTypeDiv.clone();
                                                initialPropertyTypeDiv.after(propertyTypeDiv);
                                                fillZoning(propertyTypeDiv, comp[property][i],i,flag);
                                            }
                                        }
                                        updatePropertyTriggers();
                                    } else {
                                        var input = $("[name=" + property + "]");
                                        var firstChiled = $("select[name="+property+"] option:first-child");
                                        
                                        if (input.is("input")) {
                                            if (property.indexOf('property_image_url') === 0) {
                                                if (comp[property]) {
                                                    var url = $("body").data("cdn-url") + comp[property];
                                                    var preloaderImg = document.createElement("img");
                                                    preloaderImg.src = url;
                                                    preloaderImg.addEventListener('load', loadPreLoaderImg(url));
                                                    preloaderImg.addEventListener('error', errorPreLoaderImg);
                                                }
                                            } else if (property.indexOf('date_sold') === 0) {
                                                if (comp.date_sold_for_input) {
                                                    input.val(comp.date_sold_for_input);
                                                }
                                                if (comp.date_sold_for_input) {
                                                    input.data('daterangepicker').setStartDate(comp.date_sold_for_input);
                                                }
                                                if (comp[property]) {
                                                    $("label[for='" + property + "']").addClass("active");
                                                }
                                            } else if (input.is(":radio")) {
                                                if(property == "private_comp")
                                                {
                                                    if(comp[property] == "1")
                                                    {
                                                        $("#private_compYes").prop("checked", true);
                                                    }else{
                                                        $("#private_compNo").prop("checked", true);
                                                    }
                                                }else{
                                                    $("#"+comp[property]).prop('checked',true).change();
                                                }
                                            } else {
                                                input.val(comp[property]);
                                                if (comp[property]) {
                                                    $("label[for='" + property + "']").addClass("active");
                                                }
                                            }
                                        } else if (input.is("select")) {
                                            if(comp[property]==null || comp[property]=="")
                                                firstChiled.attr("selected", "selected");
                                            else
                                                input.val(comp[property]).change();
                                            input.material_select();
                                        } else if (input.is("textarea")) {
                                            input.val(comp[property]).change();
                                            input.keyup();
                                        }

                                        if (property == 'additional_amenities') {
                                            input = $("#additional_amenities");
                                            let allSelectedValues = comp[property];
                                            let selectedVal = JSON.parse(allSelectedValues);
                                            if(selectedVal==null || selectedVal=="")
                                                input.val('').change();
                                            else
                                                input.val(selectedVal).change();
                                            input.material_select();
                                        }
                                    }
                                }
                            }
                        }
                        MapController.CompsPin.setSelectedPin();
                    },
                    failure: function (errMsg) {
                        Utils.unsetIndexes('zonings');
                    }
                }).done(function () {
                    Utils.unsetIndexes('zonings');
                    $('.standalone-datepicker').each(function() { 
                        if($(this).val()!=""){
                            $(this).data('daterangepicker').setStartDate($(this).val());
                            $(this).data('daterangepicker').setEndDate($(this).val());
                        }else{
                            $(this).data('daterangepicker').setStartDate(Utils.getToday());
                            $(this).data('daterangepicker').setEndDate(Utils.getToday());
                        }
                    });
                    focusInPostMasks();
                    if ($(".check_fields").length) {
                        if(($(".select_type:checked").val() !== "sale" || $(".select_comp_type:checked").val()=="land_only") && $(".check_fields").hasClass('hide-if-land-only') && $(".check_fields").attr('data-ref')=="sale") {
                            $(".check_fields").addClass('hide');
                        }else{
                            $(".check_fields").removeClass('hide');
                        }
                    }
                });
            };
    
            var openForm = function (id, addToEvaluation) {
                clearForm();
                $('.back-comps').click();
                if (id) {
                    $('#save-comp').text('Update');
                    $('#action').text('Edit');
                    $('#delete-comp').show();
                    fillInputs(id);
                } else {
                    resetForm();
                    $("#private_compNo").prop("checked", true);
                    $('#save-comp').text('Create');
                    $('#action').text('Create');
                    $('#delete-comp').hide();
                    if (addToEvaluation) {
                        $("#addToEvaluation").val("yes");
                    }
                }
                $('.side-nav').scrollTop(0);
            };

            var closeForm = function () {
                $('.button-collapse').sideNav('hide');
                $('#comps-form').find('input[type="text"]').blur();
                $(".comps-image").fadeTo("fast", 1);
                $("#comps-form").validate().resetForm();
                $('#image').cropper('destroy');
            };

            var showDetails = function(el) {
                $('.details').scrollTop(0);
                var id = $(el).attr('data-id');
    
                $.ajax({
                    url: $("body").data("base-url") + 'res_comps/get',
                    data: {id: id, normalize: true},
                    beforeSend: function () {
                        $('.drawer').addClass('open');
                        $("body").LoadingOverlay("show",
                            {
                                image: $('body').attr('data-base-url') + "assets/img/loading.png",
                                imageAnimation: '2500ms rotate_left',
                                zIndex: 1002,
                                background: "rgba(255, 255, 255, 0.95)"
                            }
                        );
                    },
                    success: function (responseText) {
                        window.scrollTo(0, 0);
                        var data = JSON.parse(responseText);
                        fillDetails(data);
                    }
                }).done(function (data) {
                    initCarousel();
                    $('body').LoadingOverlay("hide");
                    window.scrollTo(0, 0);
                });
            };

            var fillDetails = function (data) {
                try {
                    var compDetail = $('#property-detail');
                    var body = $('body');
    
                    /*Property section*/
                    var comp = data;
                    var row="";
                    for (var i = 0; i < comp.zonings.length; i++) {
                        row += comp.zonings[i].zone_for_view +" - "+ comp.zonings[i].subzone_for_view +" - "+ comp.zonings[i].total_sq_ft_for_view +" SF<br>";
                    }
                    compDetail.find('.content [data-ref=prop_table_body]').html(row);
                    compDetail.find('.content [data-ref=building_size]').html(comp.building_size_for_view);
                    compDetail.find('.content [data-ref=property_name]').html(comp.property_name);
                    compDetail.find('.content [data-ref=street_address]').html(comp.street_address);
                    compDetail.find('.content [data-ref=city]').html(comp.city);
                    compDetail.find('.content [data-ref=state]').html(comp.state_for_view);
                    compDetail.find('.content [data-ref=zipcode]').html(comp.zipcode);
                    compDetail.find('.content [data-ref=summary]').html(comp.summary);
                    compDetail.find('.content [data-ref=summary]').attr('style','text-align: justify');
                    var land_dimension = "SF";
                    if(comp.land_dimension == "ACRE")
                        land_dimension = "Acres";
                    compDetail.find('.content [data-ref=land_size]').html(comp.land_size_for_view);
                    compDetail.find('.content [data-ref=topography]').html(comp.topography_type);
                    compDetail.find('.content [data-ref=lot_Shape]').html(comp.lot_shape_type);
                    compDetail.find('.content [data-ref=frontage]').html(comp.frontage_for_view);
                    compDetail.find('.content [data-ref=condition]').html(comp.condition_for_view);
                    compDetail.find('.content [data-ref=year_built]').html(comp.year_built);
                    compDetail.find('.content [data-ref=year_remodeled]').html(comp.year_remodeled);
                    compDetail.find('.content [data-ref=utilities]').html(comp.utilities_for_view);
                    compDetail.find('.content [data-ref=basement]').html(comp.basement_type);
                    compDetail.find('.content [data-ref=zoning_type]').html(comp.zoning_type);
                    compDetail.find('.content [data-ref=sale_price]').html(comp.sale_price_for_view);
                    compDetail.find('.content [data-ref=date_sold]').html(comp.date_sold_for_view);
                    compDetail.find('.content [data-ref=list_price]').html(comp.list_price_for_view);
                    compDetail.find('.content [data-ref=date_list]').html(comp.date_list_for_view);
                    compDetail.find('.content [data-ref=days_on_market]').html(comp.days_on_market);
                    compDetail.find('.content [data-ref=total_concessions]').html(comp.total_concessions_for_view);
                    compDetail.find('.content [data-ref=offeror_name]').html(comp.offeror_name);
                    compDetail.find('.content [data-ref=acquirer_name]').html(comp.acquirer_name);
                    compDetail.find('.content [data-ref=exterior]').html(comp.exterior_type);
                    compDetail.find('.content [data-ref=roof]').html(comp.roof_type);
                    compDetail.find('.content [data-ref=electrical]').html(comp.electrical_type);
                    compDetail.find('.content [data-ref=plumbing]').html(comp.plumbing_type);
                    compDetail.find('.content [data-ref=heating_cooling]').html(comp.heating_cooling_type);
                    compDetail.find('.content [data-ref=windows]').html(comp.windows_type);
                    compDetail.find('.content [data-ref=bedrooms]').html(comp.bedrooms_type);
                    compDetail.find('.content [data-ref=bathrooms]').html(comp.bathrooms_type);
                    compDetail.find('.content [data-ref=garage]').html(comp.garage_type);
                    compDetail.find('.content [data-ref=fencing]').html(comp.fencing_type);
                    compDetail.find('.content [data-ref=fireplace]').html(comp.fireplace_type);
                    let additional_amenities = comp.additional_amenities;
                    if(comp.other_amenities !== '' && comp.other_amenities !== null)
                    {
                        // additional_amenities = JSON.parse(additional_amenities).join(', ');
                        additional_amenities = additional_amenities.map(function(obj) {
                            return obj.additional_amenities;
                        }).join(', ');
                    }
                    compDetail.find('.content [data-ref=additional_amenities]').html(additional_amenities);
                    compDetail.find('.content [data-ref=other_amenities]').html(comp.other_amenities);

                    // $('#link-to-edit-form').attr('onclick', 'ResCompsController.openForm("'+ comp.id +'")');
                    $('#link-to-edit-form').attr('href', $("body").data("base-url")+'/res_comps/overview/'+ comp.id);
                
                    /*Images*/
                    if (comp.property_image_url !== null) {
                        compDetail.find('.content [data-ref=image_url]').css('background-image', 'url("' + Utils.imageUrl(comp.property_image_url) + '")');
                    } else {
                        compDetail.find('.content [data-ref=image_url]').css('background-image', 'url('+$("body").data("base-url")+'assets/img/no-photo-available.png');
                    }
                    var map_image = getCompImage(comp.map_pin_lat, comp.map_pin_lng, comp.map_pin_zoom);
    
                    if (map_image && map_image.length > 0) {
                        compDetail.find('.content [data-ref=map_image_url]').css('background-image', 'url("' + map_image + '")');
                    } else {
                        compDetail.find('.content [data-ref=map_image_url]').css('background-image', 'url('+$("body").data("base-url")+'assets/img/no-photo-available.png');
                    }
                } catch (err) {
                    console.log('It is not possible to load the property at the moment.');
                    console.log(err);
                }
            };

            var getCompImage = function (latitude,longitude,map_zoom) {
                var imageDim = {height: 640, width: 640};
                var size = imageDim.width + "x" + imageDim.height;
                var zoom = map_zoom;
                var type = 'hybrid';
                var icon = $('#listings-map').attr('data-icon');
                var center = latitude + "," + longitude;
                center = center.replace(/ /g, "+");
                var url = "https://maps.googleapis.com/maps/api/staticmap?size=" + size + "&zoom=" + zoom + "&center=" + center + "&maptype=" + type + "&markers=icon:" + icon + "|" + center + "&key=" + MapController.getKey();
                return url;
            };

            var initCarousel = function () {
                $('.carousel.carousel-slider').carousel({fullWidth: true});
                // move next carousel
                $('.moveNextCarousel').click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $('.carousel.carousel-slider').carousel('next');
                });
                // move prev carousel
                $('.movePrevCarousel').click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $('.carousel.carousel-slider').carousel('prev');
                });
                $('.materialboxed').materialbox();
            };

            var closeDetails = function () {
                $('.drawer').removeClass('open');
                window.scrollTo(0, 0);
                history.pushState("", document.title, window.location.pathname + window.location.search);
            };
    
            if (window.ResCompsController === undefined) {
                window.ResCompsController = {};
            }
    
            window.ResCompsController = {
                "openForm": openForm,
                "closeForm": closeForm,
                "resetForm": resetForm,
                "saveComp": saveComp,
                "loadSideNav": loadSideNav,
                "showDetails": showDetails,
                "closeDetails":closeDetails
            };
            let searchParam = location.search.indexOf('evaluation');
            if(searchParam == -1){
                initialize();
            }
            loadSideNav();
        }
    })();
});